import { Expandable } from "@components/atoms/Expandable"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Expandable Item",
}

export default defineBlock("content/expandable-item", (props) => {
  return (
    <Expandable
      label={
        <EditableText
          store="title"
          as="span"
          placeholder="Expandable Item Title"
          defaultValue="Expandable Item Title"
        />
      }
      icon={
        <svg className="w-4 h-4 md:w-3 md:h-3" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5.30769 6.69231H0V5.30769H5.30769V0H6.69231V5.30769H12V6.69231H6.69231V12H5.30769V6.69231Z"
            fill="currentColor"
          />
        </svg>
      }
      iconOpen={
        <svg className="w-4 h-4 md:w-3 md:h-3" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5.30769 6.69229H0V5.30768H5.30769L6.69231 5.30775L12 5.30768V6.69229H6.69231H5.30769Z"
            fill="currentColor"
          />
        </svg>
      }
      className="text-slate950"
    >
      <div className="w-full rich-text-group pt-5 pb-7">
        <InnerBlocks allowedBlocks={["#inline"]} defaultBlocks={[["core/paragraph", {}]]} orientation="vertical" />
      </div>
    </Expandable>
  )
})
